import { e as l } from "../separate-component-helper-chunks/base-CwU3eNq-.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function d(c, h) {
  return (r, o, n) => {
    const u = (s) => {
      var e, t;
      return (t = (e = s.renderRoot) == null ? void 0 : e.querySelector(c)) != null ? t : null;
    };
    if (h) {
      const { get: s, set: e } = typeof o == "object" ? r : n != null ? n : (() => {
        const t = Symbol();
        return { get() {
          return this[t];
        }, set(i) {
          this[t] = i;
        } };
      })();
      return l(r, o, { get() {
        let t = s.call(this);
        return t === void 0 && (t = u(this), (t !== null || this.hasUpdated) && e.call(this, t)), t;
      } });
    }
    return l(r, o, { get() {
      return u(this);
    } });
  };
}
export {
  d as query
};
